import { render } from "./AnalyticsPerfectionTotal.vue?vue&type=template&id=19346128&scoped=true"
import script from "./AnalyticsPerfectionTotal.vue?vue&type=script&lang=js"
export * from "./AnalyticsPerfectionTotal.vue?vue&type=script&lang=js"

import "@/css/components/analytics-perfection-total.css?vue&type=style&index=0&id=19346128&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19346128"]])

export default __exports__